import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "a" };
const _hoisted_2 = { class: "b" };
const _hoisted_3 = { class: "c" };
const _hoisted_4 = { class: "d" };
const _hoisted_5 = { class: "d-flex align-center" };
const _hoisted_6 = { class: "e" };
const _hoisted_7 = { class: "brg-error-message" };
import { onMounted, ref, } from 'vue';
import { storeToRefs } from 'pinia';
import { pStore } from '@/pinia';
import { getFormValueForPinia, setFormValueForPinia, validateForm, } from '@/utils/form';
import { createRequestMapFormRule } from '@/form/form-rules/requestMap';
import InputRow from '@/components/Form/InputRow.vue';
import AxiosResponse from '@/error/AxiosResponse';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import vuexStore from '@/vuex-store';
import { BusinessError } from '@/error';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BrgMapSearchForm',
    setup(__props) {
        const areaTypeRef = ref(null);
        const eupMyeonDongRef = ref(null);
        const mainLotNumberRef = ref(null);
        const barogoAddressWrapperRef = ref(null);
        const isError = ref(null);
        const formRule = createRequestMapFormRule();
        const { formData, areaList, } = storeToRefs(pStore.piniaRequestMap);
        const getFormValue = (key) => getFormValueForPinia(formData, key);
        const setFormValue = (key, value) => setFormValueForPinia(formData, key, value);
        /**
         * 주소 검색 액션
         */
        const actionGetItem = async () => {
            pStore.piniaRequestMap.formData.selectedAddress = null;
            const refList = [
                areaTypeRef.value,
                eupMyeonDongRef.value,
                mainLotNumberRef.value,
            ];
            const { isValid } = await validateForm(refList);
            isError.value = !isValid;
            if (!isValid) {
                return;
            }
            try {
                await pStore.piniaRequestMap.getBrgMapAddressList();
            }
            catch (error) {
                if (error instanceof BusinessError) {
                    vuexStore.dispatch(snackbarActionType.showError, error.message);
                }
                if (error instanceof AxiosResponse) {
                    vuexStore.dispatch(snackbarActionType.showError, error.data.error.message);
                }
            }
        };
        /**
         * 지역 타입 변경 핸들러
         * @param value
         */
        const handleChangeAreaTypeSelect = (value) => {
            setFormValue('areaTypeCode', value.name);
            setFormValue('areaTypeKr', value.description);
        };
        /**
         * 주소 검색 버튼 클릭 핸들러
         */
        const handleClickAddressSearchBtn = async () => {
            await actionGetItem();
        };
        /**
         * 주소 검색에서 엔터 클릭 핸들러
         * @param event
         */
        const handleClickSubmitBtn = async (event) => {
            if (event.key === 'Enter') {
                await actionGetItem();
            }
        };
        /**
         * 이벤트 바인딩
         */
        const bindEvent = () => {
            barogoAddressWrapperRef.value.addEventListener('keydown', handleClickSubmitBtn);
        };
        onMounted(() => {
            pStore.piniaRequestMap.getAreaList();
            bindEvent();
        });
        return (_ctx, _cache) => {
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    ref_key: "barogoAddressWrapperRef",
                    ref: barogoAddressWrapperRef,
                    class: "barogo-address-wrapper"
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createCommentVNode(" 지역 "),
                        _createVNode(InputRow, {
                            label: "지역",
                            "is-vertical-label": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                    class: "cy-area-type",
                                    ref_key: "areaTypeRef",
                                    ref: areaTypeRef,
                                    "item-title": "description",
                                    "item-value": "name",
                                    density: "compact",
                                    variant: "outlined",
                                    "hide-details": "",
                                    "return-object": "",
                                    placeholder: "지역선택",
                                    "model-value": _unref(formData).areaTypeKr,
                                    rules: _unref(formRule).areaType,
                                    items: _unref(areaList),
                                    "onUpdate:modelValue": handleChangeAreaTypeSelect
                                }, null, 8 /* PROPS */, ["model-value", "rules", "items"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                        _createCommentVNode(" 읍면동 "),
                        _createVNode(InputRow, {
                            label: "읍면동",
                            "is-vertical-label": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    ref_key: "eupMyeonDongRef",
                                    ref: eupMyeonDongRef,
                                    class: "cy-eup-myeon-dong",
                                    density: "comfortable",
                                    variant: "outlined",
                                    "hide-details": "",
                                    "validate-on": "blur",
                                    rules: _unref(formRule).eupMyeonDong,
                                    "model-value": getFormValue('eupMyeonDong'),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => setFormValue('eupMyeonDong', value))
                                }, null, 8 /* PROPS */, ["rules", "model-value"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(InputRow, {
                            label: "리 (선택)",
                            "is-vertical-label": ""
                        }, {
                            default: _withCtx(() => [
                                _createCommentVNode(" 리 "),
                                _createVNode(_component_v_text_field, {
                                    class: "cy-ri",
                                    density: "comfortable",
                                    variant: "outlined",
                                    "hide-details": "",
                                    "validate-on": "blur",
                                    disabled: !_unref(formData).eupMyeonDong,
                                    "model-value": getFormValue('ri'),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => setFormValue('ri', value))
                                }, null, 8 /* PROPS */, ["disabled", "model-value"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(InputRow, {
                            label: "번지",
                            "is-vertical-label": ""
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                    _createCommentVNode(" 주번지 "),
                                    _createVNode(_component_v_text_field, {
                                        ref_key: "mainLotNumberRef",
                                        ref: mainLotNumberRef,
                                        class: "cy-main-lot-number",
                                        density: "comfortable",
                                        variant: "outlined",
                                        "hide-details": "",
                                        "validate-on": "blur",
                                        rules: _unref(formRule).mainLotNumber,
                                        "model-value": getFormValue('mainLotNumber'),
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => setFormValue('mainLotNumber', value))
                                    }, null, 8 /* PROPS */, ["rules", "model-value"]),
                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mx-1" }, [
                                        _createElementVNode("span", null, "-")
                                    ], -1 /* CACHED */)),
                                    _createVNode(_component_v_text_field, {
                                        class: "cy-title",
                                        density: "comfortable",
                                        variant: "outlined",
                                        "hide-details": "",
                                        "validate-on": "blur",
                                        "model-value": getFormValue('subLotNumber'),
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = (value) => setFormValue('subLotNumber', value))
                                    }, null, 8 /* PROPS */, ["model-value"])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createCommentVNode(" 완료 "),
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            class: "cy-brg-map-submit-btn",
                            onClick: handleClickAddressSearchBtn
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                        _createTextVNode(" mdi-magnify ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [5]
                                }),
                                _cache[6] || (_cache[6] = _createTextVNode(" 검색 "))
                            ]),
                            _: 1 /* STABLE */,
                            __: [6]
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    primary: true,
                                    "size-l": true,
                                    "width-xs": true
                                }
                            ]
                        ])
                    ])
                ], 512 /* NEED_PATCH */),
                _createCommentVNode(" 경고 메시지 "),
                _withDirectives(_createElementVNode("div", _hoisted_7, [
                    _createCommentVNode(" 다른 값 채크해서 유효성 검사 처리 "),
                    _createVNode(_component_v_text_field, {
                        class: "brg-input-hidden",
                        type: "hidden",
                        rules: [() => !isError.value]
                    }, null, 8 /* PROPS */, ["rules"]),
                    _cache[7] || (_cache[7] = _createTextVNode(" 지역, 읍면동, 번지는 필수 입니다. "))
                ], 512 /* NEED_PATCH */), [
                    [_vShow, isError.value]
                ])
            ]));
        };
    }
});
